import React from 'react';

interface StepCardProps {
  children: React.ReactNode;
  className?: string;
}

export const StepCard = ({ children, className = '' }: StepCardProps) => {
  return (
    <div className={`bg-white rounded-xl border border-gray-200 py-4 px-4 w-full max-w-full h-[440px] ${className}`}>
      {children}
    </div>
  );
};